import { Operatingunit } from '@cbgms/api/modules/enums'

export const OPERATING_UNIT = [
  { key: Operatingunit.ModelOu, value: Operatingunit.ModelOu, text: 'MODEL_OU' },
  { key: Operatingunit.PVOu, value: Operatingunit.PVOu, text: 'DE_PVA' },
  { key: Operatingunit.StakisOu, value: Operatingunit.StakisOu, text: 'DE_SG' }
]
